import { useQuery } from "react-query";
import { LoyaltyApi } from "../../services";
export function useLoyaltyReward(prizeUuid) {
    return useQuery(["LoyaltyApi.getReward", prizeUuid], () => LoyaltyApi.init().getReward(prizeUuid), {
        enabled: Boolean(prizeUuid),
    });
}
//# sourceMappingURL=useLoyaltyReward.js.map